"use client";
import {JSX, MouseEvent} from "react";

import {useTranslation} from "@/shared/i18n";
import {DateHelper} from "@/shared/lib/helpers/date";
import {Typography} from "@/shared/ui/data-display/typography";

import {type DateRangePickerTriggerProps} from "../../daterange-picker-field";

import "./styles/daterange-filter-trigger.scss";

export function DateRangeFilterTriggerSmall(props: DateRangePickerTriggerProps): JSX.Element {
    const {startDate, endDate, disabled, hasValue, onClick, onClear} = props;
    const {t} = useTranslation("search");

    const handleClearClick = (e: MouseEvent): void => {
        e.stopPropagation();
        onClear();
    };

    // Format: "Jul 10-14" (same month) or "Jul 10 - Aug 14" (different months)
    const dateRangeValue = DateHelper.formatDateRangeCompact(startDate, endDate);

    return (
        <div className="daterange-filter-trigger-wrapper ">
            <button type="button" onClick={onClick} disabled={disabled} className="daterange-filter-trigger input-field__wrapper">
                {hasValue && !disabled && dateRangeValue ? (
                    <Typography as="span" size={14} weight={400} color="title" className="daterange-filter-trigger__value">
                        {dateRangeValue}
                    </Typography>
                ) : (
                    <Typography as="span" size={14} weight={400} color="paragraph">
                        {t("enterDates")}
                    </Typography>
                )}
            </button>

            {hasValue && !disabled && (
                <button type="button" onClick={handleClearClick} className="daterange-filter-trigger__clear" aria-label={t("$.common.clear")}>
                    ×
                </button>
            )}
        </div>
    );
}
